document.addEventListener("teeinblue-event-component-injected", function () {
  const insertAfterElement = document.querySelector(".tee-product-price");
  const productBlocks = document.querySelectorAll(".product-block");
  let elementToMove = null;
  let elementToMove2 = null;
  productBlocks.forEach((block) => {
    if (block.textContent.trim() == "Limited time deal") {
      elementToMove = block;
    }
  });
  productBlocks.forEach((block) => {
    if (
      block.textContent.includes(
        "Black Friday Starts Early: 40% OFF – Lowest Price of the Year!"
      )
    ) {
      console.log(block);
      elementToMove2 = block;
    }
  });
  if (elementToMove2 && insertAfterElement) {
    insertAfterElement.after(elementToMove2);
  }
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});

document.addEventListener('teeinblue-event-component-injected', function() {
    const elementToMove3 = document.querySelector('.promo-bar-container');
    const insertAfterElement3 = document.querySelector('.tee-product-price');
    if (elementToMove3 && insertAfterElement3) {        
     insertAfterElement3.after(elementToMove3)
    } 

    const elementToMove4 = document.querySelector('.after-price-block');
    const insertAfterElement4 = document.querySelector('.tee-product-price');
    if (elementToMove4 && insertAfterElement4) {        
     insertAfterElement4.after(elementToMove4)
    } 
});

